"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoryOrderList = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const interface_1 = require("../../../interface");
const utils_1 = require("../utils");
/**
 * 历史仓位列表
 * @param params SimpleFutures.OrderListUIParams
 * @returns SimpleFutures.OrderListUIResponse
 */
const useHistoryOrderList = () => {
    const [orders, setOrders] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [isLastPage, setIsLastPage] = (0, react_1.useState)(false);
    const [isLoadingMore, setIsLoadingMore] = (0, react_1.useState)(false);
    const [isRefreshing, setIsRefreshing] = (0, react_1.useState)(false);
    const refState = (0, react_1.useRef)({});
    // 首次触发加载一次订单数据
    (0, react_1.useEffect)(() => {
        loadMore();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getDataObservable = (0, react_1.useCallback)(() => {
        return SimpleFuturesAPI_1.SimpleFuturesAPI.getOrderList((0, lodash_1.omitBy)({
            page_token: refState.current.nextPageToken,
            status: interface_1.SimpleFutures.OrderStatus.finished,
        }, lodash_1.isUndefined));
    }, []);
    /** 加载更多，获取下一页数据 */
    const loadMore = (0, react_1.useCallback)(() => {
        if (refState.current.isFetching || isLastPage) {
            return;
        }
        setIsLoadingMore(true);
        refState.current.isFetching = true;
        return getDataObservable().subscribe({
            next: (res) => {
                var _a;
                const newData = ((_a = res.results) === null || _a === void 0 ? void 0 : _a.map(utils_1.SimpleFuturesUtils.transferOrderAPIToUI)) || [];
                if (!refState.current.nextPageToken) {
                    setOrders(newData);
                }
                else {
                    setOrders((histories = []) => {
                        return histories === null || histories === void 0 ? void 0 : histories.concat(newData);
                    });
                }
                setIsLastPage(!res.next_page_token);
                refState.current.nextPageToken = res.next_page_token || undefined;
            },
            error: (err) => {
                setError(err);
                setIsLastPage(true);
                setIsLoadingMore(false);
                refState.current.isFetching = false;
            },
            complete: () => {
                setIsLoadingMore(false);
                refState.current.isFetching = false;
            },
        });
    }, [getDataObservable, isLastPage]);
    /** 刷新数据 */
    const refresh = (0, react_1.useCallback)((withoutLoading) => {
        if (refState.current.isFetching) {
            return;
        }
        // 清空分页信息
        refState.current.nextPageToken = undefined;
        if (!withoutLoading) {
            setIsRefreshing(true);
        }
        refState.current.isFetching = true;
        return getDataObservable().subscribe({
            next: (res) => {
                var _a;
                const newData = ((_a = res.results) === null || _a === void 0 ? void 0 : _a.map(utils_1.SimpleFuturesUtils.transferOrderAPIToUI)) || [];
                setOrders(newData);
                setIsLastPage(!res.next_page_token);
                refState.current.nextPageToken = res.next_page_token || undefined;
            },
            error: (err) => {
                setError(err);
                setIsRefreshing(false);
                refState.current.isFetching = false;
            },
            complete: () => {
                setIsRefreshing(false);
                refState.current.isFetching = false;
            },
        });
    }, [getDataObservable]);
    return {
        orders,
        error,
        isLastPage,
        isLoadingMore,
        isRefreshing,
        loadMore,
        refresh,
    };
};
exports.useHistoryOrderList = useHistoryOrderList;
